module.exports = __webpack_public_path__ + "img/179.3d4bca03.jpg";